import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 13\" id=\"icon-export\">\n    <path class=\"st0\" d=\"M13.4,6.3c0.2,0,0.3,0.1,0.4,0.2C13.9,6.6,14,6.7,14,6.9v4.4c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.8,0.5-1.2,0.5  H2.8c-0.5,0-0.9-0.2-1.3-0.5C1.2,12.1,1,11.7,1,11.2V6.9C1,6.7,1,6.6,1.2,6.4c0.1-0.1,0.3-0.2,0.4-0.2S1.9,6.3,2,6.4  c0.1,0.1,0.2,0.3,0.2,0.4v4.4c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2h9.5c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4  V6.9c0-0.2,0.1-0.3,0.2-0.4C13.1,6.3,13.2,6.3,13.4,6.3L13.4,6.3L13.4,6.3z M7.5,9.4L7.5,9.4c-0.2,0-0.3-0.1-0.4-0.2l-3-3  C4,6.2,3.9,6.1,3.9,5.9c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2l1.9,1.9V0.6c0-0.2,0.1-0.3,0.2-0.4  C7.2,0.1,7.3,0,7.5,0s0.3,0.1,0.4,0.2C8,0.3,8.1,0.4,8.1,0.6v6.8L10,5.5c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2  C11,5.6,11,5.7,11,5.9c0,0.2-0.1,0.3-0.2,0.4l-3,3C7.8,9.4,7.6,9.4,7.5,9.4L7.5,9.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/export.svg
// module id = IbHD
// module chunks = 12